export default {"src":"/org/_next/static/media/messages.0722bd05.svg","height":22,"width":24,"blurWidth":0,"blurHeight":0};